<template>

  <div class="card card-with-search border-0 card-with-shadow card-with-shadow-parent ">
    <div class="text-justify">
      <div class="row">
        <!-- <dynamic-form-preview v-bind:Id="id"></dynamic-form-preview> -->
        <div class="col-sm-12">
            <div id="pdf-section" class="container-wrapper" ref="pdfSection" >
              <div class="stacked-divs" id="print">
                <!-- Header -->
                <div class="position-relative form-header-screening p-3" ref="pdfSectionHeader">
                  <table class="my-3 align-items-center container_btn" v-if="companyInfo != null" style="width: 100%; border-collapse: collapse;">
                    <tr>
                      <td class="" style="width: 60%;">
                        <table class="user-header-media" style="width: 100%;  font-size: 0.8rem;">
                          <tr>
                            <td style="width: 30%; padding-right: 1rem;">
                              <img v-if="companyInfoCheck.checked_logo == true" :src="companyInfo.logo" alt="LOGO" style="width: 100%; height: auto;" />
                            </td>
                            <td>
                              <h6 class="mb-0">{{ companyInfoCheck.checked_company_name == true ? companyInfo.company_name : ''}} <span v-if="companyInfoCheck.checked_category_name == true">{{ ' (' + companyInfo.category_name + ')' }}</span></h6>
                              <p class="mt-2" v-if="companyInfoCheck.checked_company_number == true">Reg No. {{ companyInfo.comapny_number }}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="width: 40%; ">
                        <table style="width: 100%;  font-size: 0.8rem;">
                          <tr v-if="companyInfoCheck.checked_company_phone == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'phone'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.company_phone }}</p>
                            </td>
                          </tr>
                          <tr v-if="companyInfoCheck.checked_company_email == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'mail'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.company_email }}</p>
                            </td>
                          </tr>
                          <tr v-if="companyInfoCheck.checked_address == true">
                            <td style="padding-right: 1rem;">
                              <app-icon :name="'map-pin'" class="icon-size"/>
                            </td>
                            <td>
                              <p class="mb-1">{{ companyInfo.address }}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div class="col-12 text-center">
                    <p class="mb-2" v-if="companyInfoCheck.checked_description == true">
                      {{ companyInfo.description }}
                    </p>
                  </div>
                </div>
                <!-- Header Ends-->

                <div class="main__wrapper header-color-style formStyle form-inner-container-screening p-3">


                <el-container>
                  <el-main :style="cssProps" >
                    <el-form class="formElements">
                      <template v-for="(eachFormObj, eachFormIndex) in forms">
<!--                        <div v-if="eachFormIndex > 0" class="html2pdf__page-break"/>-->

                        <el-col :span="24" v-if="showSectionSwitch">
                          <el-checkbox  v-model="eachFormObj.showSection">Check if applicable</el-checkbox>
                        </el-col>
                        <el-divider :key="`divider-${eachFormIndex}`" content-position="center">{{ eachFormObj.title }}</el-divider>
                        <el-row :key="`row-${eachFormIndex}`" v-show="getSectionView(eachFormIndex)">
                          <div class="wrapper--forms">
<!--                            <el-col :xs="24" :sm="24"-->
                            <el-col
                                    v-for="(field, index) in eachFormObj.fields"
                                    :key="index"
                                    :span="field.span"
                                    v-bind="field"
                                    class="form__group position-relative">

                              <div>
                                <component :is="field.fieldType"
                                           :currentField="field"
                                           class="form__field"
                                ></component>

                              </div>

                              </el-col>

                          </div>
                          </el-row>

                      </template>
                    </el-form>
                  </el-main>
                </el-container>
                  <div class="form-footer" ref="formFooter">
                    <div class="row btn-border m-3 align-items-center"/>
                    <div style="display: flex; justify-content:space-between" class="ml-4 mr-4">
                      <p>
                        <small>Form ID:
                          {{ companyInfo.company_name && companyInfo.company_name.match(/\b(\w)/g).join('') + 'C' + formInfo.id }}</small>
                      </p>
                      <p>
                        <small>Version: {{ formInfo.version }}</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

        </div>

      </div>
    </div>


  </div>

</template>

<script>
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {FormBuilder} from "../../CustomFormBuilder/form_elements/formbuilder";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import {GET_FORM_RESPONSE} from "@/app/Config/ScreeningAppUrl";
import {
  getAllDocumentStyles,
  getStyles,
  setDefaultColor,
  setFormColor,
  waitForStylesheets,
    getSectionView
} from '@Views/CustomFormBuilder/utilities/formPreview'

export default {
  name: "FormResponse",

  components: {
    ...FormBuilder.$options.components,

  },
  mixins: [ModalMixin, FormMixin],
  props: {
    form_body_id:  {type:Number, required: true},
    form_id:  {type:Number, required: true},
    task_id:  {type:Number, required: true},
    user_id:  {type:Number, required: true},
    form_revision_id: {type:Number, required: true},
  },
  data() {
    return {
      showSectionSwitch: true,
      updateStrategyList: [
        {
          id: 'update',
          value: 'Update Existing'
        },{
          id: 'create',
          value: 'Create New'
        },],
      componentFieldId: 0,
      isUpdateStrategy: 'create',
      is_shareResponse: this.$props.data?.shareResponse ?? false,
      isNewTab: this.new_tab ?? 'no',
      isLock: this.lock ?? 'no',
      isActive: false,
      responseStatus: '',
      // flag: null,
      // formDesign: this.$store.state.formdesigner.formstyling,
      savedFormBodyStyle:[],
      activeName: 1,
      companyInfoCheck: {
          checked_company_name: false,
          checked_logo: false,
          checked_company_number: false,
          checked_company_email: false,
          checked_company_phone: false,
          checked_address: false,
          checked_description: false,
          checked_category_name: false,
        },
      formStatus: '',
      hideOnPrint:false,
      formInfo: {},
      on_select: false,
      form_color: "",
      form_background_color: "",
      form_header_color: "",
      form_header_text_color: "",
      font_color: "",
      select_color: [{
        form_header_color: this.form_header_color,
        form_header_text_color: this.form_header_text_color,
        form_color: this.form_color,
        font_color: this.font_color,
        form_background_color: this.form_background_color,
      }],
      // form_border_color: "",
      root: null,
      // accentColor: '#000',
      view_type: "",
      companyInfo: {},
      textCommentId: 0,
      commentRequest: {},
      textComment: {},
      created_by: 0,
      forms: this.$store.state.formBuilder.forms,
      themingVars: this.$store.state.formBuilder.themingVars,
      preloader: false,
      actionPreloader: false,
      showComments: false,
      showActions: true,
      inputs: {
        yes: "no"
      },
    };
  },
  methods: {
    getSectionView,
     getData() {
       let url = `${GET_FORM_RESPONSE}/${this.form_body_id}?form_id=${this.form_id}&form_revision_id=${this.form_revision_id}&task_id=${this.task_id}&type=${this.type}&user_id=${this.user_id}&batch=1`;

      axiosGet(url)
        .then(res => {

          if (res.data.length !== 0) {
            // this.forms = res.data.body;
            this.forms = res.data.body.map(form => ({

                ...form,
                showSection: form.hasOwnProperty('showSection') ? form.showSection : true
              }));

            this.form_body_id = res.data.id;
            // this.form_id = res.data.form_id;
            this.companyInfo = res.data.companyInfo;
            this.view_type = res.data.view_type ?? '';
            this.formInfo = res.data.form_revision;
            this.created_by = res.data.form_revision.created_by;
            this.companyInfoCheck = JSON.parse(res.data.header_content);
            this.formStatus = res.data.status;
            this.responseStatus = res.data.response_status;

            let data = JSON.parse(res.data.bodyStyle);
            this.savedFormBodyStyle = data
            
            // this.changeColor(data[0].theme_no);
            if (data && data.length > 0) {
              this.root.style.setProperty("--form-color", data[0].form_color);
              this.root.style.setProperty("--font-color", data[0].font_color);
              this.root.style.setProperty("--form-header-color", data[0].form_header_color??'#fff');
              this.root.style.setProperty("--form-header-text-color", data[0].form_header_text_color??'#000000');

            } else {
              this.root.style.setProperty("--form-color", "#fff");
              // this.root.style.setProperty("--form-border-color", "#898989");
              this.root.style.setProperty("--font-color", "#000");
            }
          }
        })
        .catch((res, data) => {
          console.error(res)
          console.error(data)
          this.$toastr.e(res.response.data.message);

        });
    },

    setDefaultColor,
    setFormColor,




  },
  created() {
    // this.$store.state.inputMode.type = !this.$store.state.inputMode.type;
  },
  watch: {
    form_header_color(){
      this.root.style.setProperty("--form-header-color", this.form_header_color);
      this.select_color[0].form_header_color = this.form_header_color;
      // this.select_color[0] = { form_header_color: this.form_header_color };
      // this.select_color.unshift({ form_header_color: this.form_header_color });

    },
    form_header_text_color(){
      this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);
      // this.select_color[0].form_header_text_color = this.form_header_text_color;
      // this.select_color[0] = { form_header_text_color: this.form_header_text_color };
      this.select_color[0].form_header_text_color = this.form_header_text_color;

    },
    form_color() {
      // this.$store.state.formdesigner.formstyling = {
      //   form_color: this.form_color,
      //   form_border_color: this.form_border_color,
      //   font_color: this.font_color,

      // };
      // const form_colortest = this.form_color;
      this.root.style.setProperty("--form-color", this.form_color);
      this.select_color[0].form_color = this.form_color;



      // this.select_color[0].form_color = this.form_color;
    },
    form_border_color() {
      // this.$store.state.formdesigner.formstyling.form_border_color = this.form_border_color;
      this.root.style.setProperty(
        "--form-border-color",
        this.form_border_color
      );
      this.select_color[0].form_border_color = this.form_border_color;
    },
    font_color() {
      // this.$store.state.formdesigner.formstyling.font_color = this.font_color;
      this.root.style.setProperty("--font-color", this.font_color);
      this.select_color[0].font_color = this.font_color;
    },
  },

  computed: {
    showBackButton(){
      return this.$store.state.sharedData.sharedData?.showBackButton??false;
    },
    
    taskId(){
       return this.data?.task_id?? this.$store.state.sharedData.sharedData.taskId;
    },
    userId(){
      return this.data?.user_id?? this.$store.state.sharedData.sharedData.guestFormData.id;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    filePath() {
      return this.$store.state.uploadFilePath.dataUploadFilePath;
      //  this.$store.dispatch("setValueToPass", documents);
    },
    cssProps() {

      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }
      return result;
    },

  },
  mounted() {
    this.getData();
    this.root = document.documentElement;

  },


};
</script>
<style scoped>
.el-form-item .el-form-item {
  margin-bottom: 0 !important;
}
@media print {
  .stacked-divs{
    max-width: 100% !important;
    width: 100% !important;
  }
  /* Adjust flex properties */
  .my-3 {
    display: block; /* Ensure containers are treated as block elements */
  }

  .flex-item {
    display: block; /* Ensure items are treated as block elements */
    width: 100%; /* Ensure items take full width if needed */
    page-break-inside: avoid; /* Prevent breaking inside items if necessary */
  }
  .flex-item .float-right{
    margin-left: auto;
  }


  /* Additional print-specific adjustments */
  /* Hide any elements that are not necessary in print */
  .no-print {
    display: none !important;
  }
  body {
    margin: 0;
  }

  .no-print {
    display: none;
  }

  /* Avoid page breaks inside these elements */
  .avoid-break {
    page-break-inside: avoid;
  }

  /* Force page breaks before or after elements as needed */
  .page-break-before {
    page-break-before: always;
  }

  .page-break-after {
    page-break-after: always;
  }

  /* Ensure the content fits within the printable area */
  .print-container {
    overflow: visible;
  }
  .print-placeholder::placeholder {
    color: white; /* Color for printing */
  }
}
.form-inner-container-screening{
  box-shadow: 0 0 10px #ececec;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.form-header-screening{
  background: var(--form-header-color) !important;
  color: var(--form-header-text-color) !important;
  box-shadow: 0 0 10px #ececec;
  border-top-right-radius: 15px;

}
</style>